import script from "./WechatMpPay.vue?vue&type=script&setup=true&lang=js"
export * from "./WechatMpPay.vue?vue&type=script&setup=true&lang=js"

import "./WechatMpPay.vue?vue&type=style&index=0&id=55195fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55195fca"]])

export default __exports__